import axios from 'axios';
import { api_url } from 'config/config';

const BASE_URL = api_url;

const api = axios.create({
  baseURL: BASE_URL,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('auth_token');

  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// api.interceptors.response.use(
//   (response) => response,
//   (error) => {
//     if (error.response?.status === 401) {

//     }
//     return Promise.reject(error.response ? error.response.data.message : error.message);
//   },
// );

export const get = async (endpoint, params = {}) => {
  try {
    const response = await api.get(endpoint, { params }).catch((error) => {
      if (error.response?.data?.forceLogout) {
        localStorage.clear();
        window.location.href = '/authentication/default/jwt/login';
      }
      throw new Error(error.data.message);
    });
    return response.data;
  } catch (error) {
    throw new Error(error.message || 'Failed to fetch data');
  }
};

export const post = async (endpoint, data) => {
  try {
    const response = await api.post(endpoint, data).catch((error) => {
      if (error.response?.data?.forceLogout) {
        localStorage.clear();
        window.location.href = '/authentication/default/jwt/login';
      }
      throw new Error(error.data.message);
    });
    return response.data;
  } catch (error) {
    throw new Error(error.message || 'Failed to post data');
  }
};
export const download = async (endpoint, data = {}) => {
  try {
    const response = await api
      .post(endpoint, data, {
        responseType: 'blob', // again required!
      })
      .catch((error) => {
        if (error.response?.data?.forceLogout) {
          localStorage.clear();
          window.location.href = '/authentication/default/jwt/login';
        }
        throw new Error(error.data.message);
      });

    return response; // return full axios response
  } catch (error) {
    throw new Error(error.message || 'Failed to download file');
  }
};
